import { FC, useEffect } from "react";
import { Heading } from "@chakra-ui/react";
import { motion, useAnimation } from "framer-motion";
import { Highlight } from "~/components";

const MotionHeading = motion(Heading);

interface Props {
  content: string;
  highlightColor: string;
}

export const PlanPillar: FC<Props> = ({ content, highlightColor }) => {
  const controls = useAnimation();

  useEffect(() => {
    controls.start({ opacity: 1 });
  });

  return (
    <MotionHeading
      animate={controls}
      initial={{ opacity: 0 }}
      variant={{ base: "th-h6", md: "th-h4" }}
    >
      <Highlight highlightColor={highlightColor}>{content}</Highlight>
    </MotionHeading>
  );
};
